import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import './styles/colors.css';
import './styles/constants.css';
import './index.css';
import AuthProvider from './providers/AuthProvider';
import { useTheme } from '@mui/material/styles';
import DashboardRoutes from './routes/DashboardRoutes';
import StudentsRoutes from './routes/StudentsRoutes';
import TeachersRoutes from './routes/TeachersRoutes';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import CoursesRoutes from './routes/CoursesRoutes';
import AdsRoutes from './routes/AdsRoutes';
import FinancialRoutes from './routes/FinancialRoutes';
import ReportsRoutes from './routes/ReportsRoutes';
import AccountRoutes from './routes/AccountRoutes';
import AuthRoutes from './routes/AuthRoutes';
import WalletRoutes from './routes/WalletRoutes';
import CategoriesRoutes from './routes/CategoriesRoutes';
import AcademicRoutes from './routes/AcademicRoutes';
import SettingsRoutes from './routes/SettingsRoutes';
import { IntlProvider } from 'react-intl';
import { useConstants } from './hooks/UseConstants';
import Translation from './translation/Translation';
import { SidebarDrawerProvider } from './context/SidebarDrawerContext';

const routerBasename = (process.env.PUBLIC_URL || '').replace(/\/$/, '');

function App() {
  const { language } = useConstants();
  const theme = useTheme();
  const messages = Translation();

  return (
    <main>
      <div className="App" style={{ backgroundColor: theme.palette.background.default }}>
        <BrowserRouter basename={routerBasename}>
          <IntlProvider locale={language} messages={messages[language]}>
            <SidebarDrawerProvider>
            <Routes>
              <Route path='/' element={<Navigate to='login' />} />
              {
                AuthRoutes().map((route, index) =>
                  <Route key={index} path={route.path} element={route.element} />
                )
              }
              {
                DashboardRoutes().map((route, index) =>
                  <Route key={index} path={route.path} element={<AuthProvider role="admin"><Header /> <Sidebar />{route.element}</AuthProvider>} />
                )
              }
              {
                StudentsRoutes().map((route, index) =>
                  <Route key={index} path={route.path} element={<AuthProvider role="admin"><Header /> <Sidebar />{route.element}</AuthProvider>} />
                )
              }
              {
                TeachersRoutes().map((route, index) =>
                  <Route key={index} path={route.path} element={<AuthProvider role="admin"><Header /> <Sidebar />{route.element}</AuthProvider>} />
                )
              }
              {
                CoursesRoutes().map((route, index) =>
                  <Route key={index} path={route.path} element={<AuthProvider role="admin"><Header /> <Sidebar />{route.element}</AuthProvider>} />
                )
              }
              {
                AdsRoutes().map((route, index) =>
                  <Route key={index} path={route.path} element={<AuthProvider role="admin"><Header /> <Sidebar />{route.element}</AuthProvider>} />
                )
              }
              {
                FinancialRoutes().map((route, index) =>
                  <Route key={index} path={route.path} element={<AuthProvider role="admin"><Header /> <Sidebar />{route.element}</AuthProvider>} />
                )
              }
              {
                ReportsRoutes().map((route, index) =>
                  <Route key={index} path={route.path} element={<AuthProvider role="admin"><Header /> <Sidebar />{route.element}</AuthProvider>} />
                )
              }
              {
                AccountRoutes().map((route, index) =>
                  <Route key={index} path={route.path} element={<AuthProvider role="admin"><Header isFullWidth={true} />{route.element}</AuthProvider>} />
                )
              }
              {
                WalletRoutes().map((route, index) =>
                  <Route key={index} path={route.path} element={<AuthProvider><Header /> <Sidebar /> {route.element}</AuthProvider>} />
                )
              }
              {
                CategoriesRoutes().map((route, index) =>
                  <Route key={index} path={route.path} element={<AuthProvider role="admin"><Header /> <Sidebar />{route.element}</AuthProvider>} />
                )
              }
              {
                AcademicRoutes().map((route, index) =>
                  <Route key={index} path={route.path} element={<AuthProvider role="admin"><Header /> <Sidebar />{route.element}</AuthProvider>} />
                )
              }
              {
                SettingsRoutes().map((route, index) =>
                  <Route key={index} path={route.path} element={<AuthProvider role="admin"><Header /> <Sidebar />{route.element}</AuthProvider>} />
                )
              }
            </Routes>
            </SidebarDrawerProvider>
          </IntlProvider>
        </BrowserRouter>
      </div>
    </main>
  );
}

export default App;
